import { CosmWasmClient } from "cosmwasm";
import { comdex } from '../config/network'
import { contractAddr } from "./keplr";

const configin = {
    chainId: comdex?.chainId,
    rpcEndpoint: comdex?.rpc,
    prefix: comdex?.prefix,
};

const initialQuery = async (moduleId) => {
    const client = await CosmWasmClient.connect(configin.rpcEndpoint);
    const config = await client.queryContractSmart(contractAddr, { "query_progress": { "sender_key": localStorage.getItem("ac") + "_" + moduleId } });

    return await config;

}
export const queryNFT = async (moduleId) => {
    const client = await CosmWasmClient.connect(configin.rpcEndpoint);
    const config = await client.queryContractSmart(contractAddr, { "query_n_f_t": { "sender_key": localStorage.getItem("ac") + "_" + moduleId } });
    return await config;

}
export const viewNFT = async (nftId) => {
    const client = await CosmWasmClient.connect(configin.rpcEndpoint);
    const config = await client.queryContractSmart(contractAddr, { "nft_info": { "token_id": nftId } });
    return await config;

}
export default initialQuery;